export class CartView {
	constructor() {}

	removeSubEvent(subEventId) {
		return $(`.js-booking[data-sub-event-id=${subEventId}]`).remove();
	}

	updateSubscriptionCount(orderId) {
		let $count = this.getOrderById(orderId).find(".js-bookings-count");

		$count.text(parseInt($count.text()) - 1);

		return parseInt($count.text());
	}

	getOrderIdBySubEventId(subEventId) {
		return parseInt(
			$(`.js-booking[data-sub-event-id=${subEventId}]`).parents(".js-order").data("id")
		);
	}

	/**
	 * Удаляет и обновляет цены билетов
	 * @param order {object} - {
	 *   id {Number} - id заказа
	 *   amount, discount,
	 *   activeCarts {Object} - Ассоциативный массив получаем id мероприятия по названию
	 *   { 261: { summ, carts[{ id, price }, ... ], ... } }
	 *  }
	 */
	renderOrder(order) {
		const $order = $(`.js-order[data-id=${order.id}]`);
		let countTickets = 0;

		/* обновление суммы и скидки */
		$order.find(".js-order-event-sum").text();
		$order.find(".js-sum").text(order.amount);
		$order.find(".js-commission").text(`${order.commission} ₽`);

		this.renderOrderDiscount(order.id, order.discount, order);

		$.each(this.getOrderEvents(order.id), (i, event) => {
			const eventId = $(event).data("event-id");

			/* Если в мероприятии нет билетов то удалем */
			if (!order.activeCarts[eventId]) return $(event).remove();

			/* Проходим по каждому билету */
			$.each(order.activeCarts[eventId].carts, (i, ticket) => {
				$(event)
					.find(`.ticket-item[data-id=${ticket.id}]`)
					.find(".js-ticket-price")
					.attr("data-price", ticket.price)
					.text(ticket.price);

				countTickets++;
			});

			this.updateOrderSum(
				order.id,
				$order.find(".promo__button").hasClass("active")
					? order.amount - order.commission
					: order.amount
			);
		});

		if (!countTickets > 0) $order.remove();
		if (!$(".js-order").length > 0) return window.location.reload();
	}

	renderOrderDiscount(orderId, discount, order) {
		const $order = this.getOrderById(orderId);
		const isPromoActive = !!$order.find(".promo__input")[0]?.value;
		let sumWithoutDiscount = 0;

		$order.find(".js-order-event").each((i, el) => {
			sumWithoutDiscount += +$(el).find(".js-order-event-sum").text();
		});

		if (discount && isPromoActive) {
			$order.find(".js-order-discount").show();
			return $order
				.find(".js-promo-discount")
				.text(sumWithoutDiscount - (order.amount - order.commission));
		}

		$order.find(".js-order-discount").hide();
		return $order.find(".js-promo-discount").text("0");
	}

	showSumLoader(orderId) {
		return this.getOrderById(orderId)
			.find(".js-sum")
			.html(
				`<span style="font-size: 9px;" class="spinner-circle spinner-circle_small spinner-circle_white"></span>`
			);
	}

	updateOrderSum(orderId, sum) {
		const commission = +$(`.js-order[data-id=${orderId}]`)
			.find(".js-commission")
			.text()
			.match(/[0-9]+/);
		return this.getOrderById(orderId)
			.find(".js-sum")
			.text(sum + commission);
	}

	removeOrderTickets(orderId, tickets) {
		$.each(tickets, (i, cart) =>
			this.getOrderById(orderId).find(`.ticket-item[data-id=${cart.id}]`).remove()
		);
	}

	getOrderById(orderId) {
		return $(`.js-order[data-id=${orderId}]`);
	}

	getOrderEvents(orderId) {
		return $(`.js-order[data-id=${orderId}]`).find(".js-order-event");
	}
}
